import React from 'react';
import { observer } from 'mobx-react';

import { Card, Typography } from 'antd';

import ReactPlayer from 'react-player';

import { cardHeaderStyle } from './util/Style';

const { Title, Paragraph } = Typography;

function Premise() {

    /**
     * An introduction to why we design this platform
     */
    const getPlatformIntro = () => {
        const url = ``;
        return (
            <Card
                headStyle={cardHeaderStyle}
                style={{ marginTop: "10px", marginBottom: "10px" }}
                title={<Title level={4}>Master Data Management</Title>}>

                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", textAlign: "center", alignItems: "center" }}>
                    <div style={{ width: "40%", marginRight: 10, textAlign: "left" }}>
                        <Paragraph>
                            The portal is to assist in managing the products to help our stakeholders
                        </Paragraph>
                        <Paragraph>
                            <ul>
                                <li>The Product and its attributes</li>
                                <li>Our Customers</li>
                                <li>The Doctors</li>
                                <li>Our Partners</li>
                            </ul>
                        </Paragraph>
                    </div>
                    <div style={{ width: "60%", textAlign: "left" }}>
                        <ReactPlayer width='100%' height='100%' controls url={url} />
                    </div>
                </div>
            </Card>
        )
    }

    return (
        <div>
            {getPlatformIntro()}
        </div>
    )

}

export default observer(Premise);